<template>
  <div :class="`toast ${color}`">
    <i v-if="closable" class="bi bi-x-lg close-icon" />
    <i :class="icon" />
    <div class="content-container">
      <p v-if="title" class="bold" v-text="title" />
      <p class="small" v-safe-html="text" />
    </div>
  </div>
</template>

<script setup>
defineProps({
  color: {
    type: String,
    default: "yellow",
  },
  icon: {
    type: [String, null],
    required: true,
  },
  title: {
    type: String,
    default: "",
  },
  text: {
    type: String,
    required: true,
  },
  closable: {
    type: Boolean,
    default: true,
  },
});
</script>
